var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-link",
    transform: "translate(-1668 -11693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 48,
    height: 48,
    rx: 8,
    transform: "translate(1668 11693)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M4.946,22.095H.365V7.344H4.946ZM2.653,5.332A2.665,2.665,0,1,1,5.306,2.654,2.675,2.675,0,0,1,2.653,5.332ZM22.09,22.095H17.519V14.914c0-1.711-.035-3.906-2.382-3.906-2.382,0-2.747,1.859-2.747,3.783v7.3H7.815V7.344h4.393V9.356h.064a4.813,4.813,0,0,1,4.334-2.382c4.636,0,5.488,3.053,5.488,7.018v8.1Z",
    transform: "translate(1680.953 11705.952)",
    fill: "#05bfd7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLink);
export default __webpack_public_path__ + "static/media/icn-link.18c25df2749a4520245ef8c922dd9950.svg";
export { ForwardRef as ReactComponent };